import React, { useEffect, useState, useRef } from "react";
import {
  Clock,
  Briefcase,
  X,
  Download,
  Camera,
  Edit2,
  TrendingUp,
  CheckCircle,
} from "lucide-react";
import QRCode from "react-qr-code";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useWorker } from "../context/WorkerContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DobAddressModal from "./dob&addressModal";
import AgreementModal from "./agreementModal";
import SelfieImage from "./SelfiImage";
import WorkerDetailModal from "./workerDetailModal";
import banklogo from "../assets/bank.png";
import worker from "../assets/worker.png";
import parttime from "../assets/part-time.png";
import factory from "../assets/factory.png";
import { LogOut } from "lucide-react";
import AttendanceCard from "./AttendanceCard";
// import AdhaarVerificationModal from "./AdhaarVerificationModal";
import attendaceIcon from "../assets/attendanceIcon.png";
import payoutsIcon from "../assets/payoutsIcon.png";
import referralIcon from "../assets/referralIcon.png";
import resumeIcon from "../assets/resumeIcon.png";
import bankDetailsIcon from "../assets/bankDetails.png";
import detailsIcon from "../assets/resumeIcon.png";
import BankDetailsCard from "./BankDetailsCard";
import agreementIcon from "../assets/agreementIcon.png";
import form from "../assets/google-forms.png"
import CompaniesSection from "./CompaniesSection"; 
import powIcon from "../assets/diploma.svg";
import essentialsIcon from "../assets/grid.svg";
import { WORKER_TOKEN_KEY } from "../constants/tokenKeys";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const JobDetailsView = ({ jobDetails }) => {
  const { 
    user, 
    setUser, 
    token, 
    fetchQRLink, 
    fetchDownloadLink,
    fetchProofOfWorkLink,
    getMessageByPhone,
    submitMessageResponse,
    markMessageAsRead,
    messageCount,
    updateMessageCount,
    logout
  } = useWorker();
  const navigate = useNavigate();

  // STATE MANAGEMENT
  const [showWorkerDetailModal, setShowWorkerDetailModal] = useState(false);
  const [showSelfieModal, setShowSelfieModal] = useState(false);
  const [showBankModal, setShowBankModal] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [showViewSelfieModal, setShowViewSelfieModal] = useState(false);
  const [showDobAddressModal, setShowDobAddressModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [editType, setEditType] = useState(null);
  const [accountDetails, setAccountDetails] = useState(null);
  const [qrlink, setQrLink] = useState("");
  const [qrStatus, setQrStatus] = useState("");
  const [companies, setCompanies] = useState([]);
  const [showAadhaarModal, setShowAadhaarModal] = useState(false);
  const [userStats, setUserStats] = useState({
    totalWorkingHours: 0,
    totalShifts: 0,
    totalPaymentEarned: 0,
    totalNetPayment: 0,
    totalEarnings: 0, // Added this field
  });
  const [registrationStep, setRegistrationStep] = useState(1);

  const [messageRequests, setMessageRequests] = useState([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(null);
  const [showBankDetailsCard, setShowBankDetailsCard] = useState(false);
  
  // LOGOUT MODAL STATE 
  const [showLogoutModal, setShowLogoutModal] = useState(false);
const [isLoadingReport, setIsLoadingReport] = useState(false);

  // PULL-TO-REFRESH 
  const [pullDistance, setPullDistance] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const touchStartY = useRef(0);
  const isPullingRef = useRef(false);

  // FORCE MODAL OPEN REF
  const forceOpenAttempts = useRef(0);
  const maxForceAttempts = 10;

  // EXPOSE FUNCTIONS GLOBALLY WITH FORCE
  useEffect(() => {
    // Expose the openModalForMessageId function globally with force
    window.openModalForMessageId = async (messageId) => {
      console.log('🔔 [GLOBAL] openModalForMessageId called with:', messageId);
      await forceOpenModal(messageId);
    };
    
    // Direct force function
    window.__forceOpenNotificationModal = async (messageId) => {
      console.log('🔔 [FORCE] Direct force open called with:', messageId);
      await forceOpenModal(messageId);
    };
    
    // Ultra force function - tries everything
    window.__ULTRA_FORCE_OPEN = async (messageId) => {
      console.log('🔔 [ULTRA FORCE] Called with:', messageId);
      await forceOpenModal(messageId, true);
    };
    
    return () => {
      delete window.openModalForMessageId;
      delete window.__forceOpenNotificationModal;
      delete window.__ULTRA_FORCE_OPEN;
    };
  }, [user, messageRequests]);

  // FORCE OPEN MODAL FUNCTION 
  const forceOpenModal = async (messageId, ultraForce = false) => {
    console.log('🔔 [FORCE] forceOpenModal called with:', messageId, 'ultraForce:', ultraForce);
    
    try {
      // If no messageId, try to find one
      if (!messageId && messageRequests.length > 0) {
        messageId = messageRequests[0]._id;
        console.log('🔔 [FORCE] Using first message ID:', messageId);
      }
      
      if (!messageId) {
        console.log('🔔 [FORCE] No message ID available, fetching from API');
        // Try to fetch messages
        try {
          const response = await getMessageByPhone(user?.phone);
          if (response.success && response.count > 0) {
            setMessageRequests(response.data);
            updateMessageCount(response.count);
            messageId = response.data[0]._id;
            console.log('🔔 [FORCE] Found message from API:', messageId);
          }
        } catch (err) {
          console.error('🔔 [FORCE] Failed to fetch messages:', err);
        }
      }
      
      if (!messageId) {
        console.log('🔔 [FORCE] Still no message ID, giving up');
        toast.warning('No work requests available');
        return;
      }
      
      // Try to find in local state
      const cached = messageRequests.find((m) => m._id === messageId);
      if (cached) {
        console.log('🔔 [FORCE] Found in local state, opening modal');
        const processed = processMessage(cached);
        setCurrentMessage({
          ...cached,
          processedTitle: processed.title,
          processedBody: processed.body
        });
        setShowMessageModal(true);
        console.log('🔔 [FORCE] Modal opened from cache!');
        return;
      }
      
      // Fetch from API
      console.log('🔔 [FORCE] Not found in local state, fetching from API');
      const response = await getMessageByPhone(user?.phone);
      if (response.success && response.count > 0) {
        setMessageRequests(response.data);
        updateMessageCount(response.count);
        
        const target = response.data.find((m) => m._id === messageId);
        if (target) {
          const processed = processMessage(target);
          setCurrentMessage({
            ...target,
            processedTitle: processed.title,
            processedBody: processed.body
          });
          setShowMessageModal(true);
          console.log('🔔 [FORCE] Modal opened from API!');
          return;
        }
      }
      
      // Ultra force - direct DOM manipulation if all else fails
      if (ultraForce) {
        console.log('🔔 [ULTRA FORCE] Attempting direct DOM manipulation');
        
        // Try to find and click the message banner
        const banner = document.querySelector('.cursor-pointer.bg-gradient-to-r');
        if (banner) {
          console.log('🔔 [ULTRA FORCE] Found banner, clicking it');
          banner.click();
          setTimeout(() => {
            // Check if modal opened
            const modal = document.querySelector('.fixed.inset-0.bg-black.bg-opacity-50');
            if (!modal) {
              console.log('🔔 [ULTRA FORCE] Modal still not open, creating fallback');
              createFallbackModal(messageId);
            }
          }, 500);
        } else {
          console.log('🔔 [ULTRA FORCE] No banner found, creating fallback');
          createFallbackModal(messageId);
        }
      }
      
    } catch (error) {
      console.error('🔔 [FORCE] Error in forceOpenModal:', error);
      
      // Last resort - try to show a toast with the message
      toast.info('You have a new work request! Please check the notification banner.', {
        duration: 5000,
        onClick: () => {
          // Try to open the first message
          if (messageRequests.length > 0) {
            const first = messageRequests[0];
            const processed = processMessage(first);
            setCurrentMessage({
              ...first,
              processedTitle: processed.title,
              processedBody: processed.body
            });
            setShowMessageModal(true);
          }
        }
      });
    }
  };

  // CREATE FALLBACK MODAL
  const createFallbackModal = (messageId) => {
    console.log('🔔 [FALLBACK] Creating fallback modal for:', messageId);
    
    // Try to get message data
    getMessageByPhone(user?.phone).then(response => {
      if (response.success && response.count > 0) {
        const target = response.data.find((m) => m._id === messageId) || response.data[0];
        if (target) {
          const processed = processMessage(target);
          setMessageRequests(response.data);
          updateMessageCount(response.count);
          setCurrentMessage({
            ...target,
            processedTitle: processed.title,
            processedBody: processed.body
          });
          setShowMessageModal(true);
          console.log('🔔 [FALLBACK] Modal opened successfully!');
        }
      }
    }).catch(err => {
      console.error('🔔 [FALLBACK] Failed to fetch message:', err);
    });
  };

  // CHECK PENDING NOTIFICATION ON MOUNT WITH FORCE 
  useEffect(() => {
    const checkPendingNotification = async () => {
      console.log('🔔 [MOUNT] Checking for pending notification');
      
      // Check for pending notification ID
      let pendingId = window.__pendingNotificationMessageId;
      
      // Also check URL params
      const params = new URLSearchParams(window.location.search);
      const urlMessageId = params.get('messageId');
      if (urlMessageId) {
        console.log('🔔 [MOUNT] Found messageId in URL:', urlMessageId);
        pendingId = urlMessageId;
        // Clean URL
        params.delete('messageId');
        const qs = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''));
      }
      
      // Check localStorage
      try {
        const stored = localStorage.getItem('pendingNotificationId');
        if (stored) {
          console.log('🔔 [MOUNT] Found pending in localStorage:', stored);
          pendingId = stored;
          localStorage.removeItem('pendingNotificationId');
        }
      } catch (e) {
        console.error('🔔 [MOUNT] Error reading localStorage:', e);
      }
      
      if (pendingId) {
        console.log('🔔 [MOUNT] Found pending ID, forcing open:', pendingId);
        window.__pendingNotificationMessageId = null;
        
        // Force open with multiple attempts
        setTimeout(async () => {
          await forceOpenModal(pendingId, true);
        }, 500);
        
        // Second attempt if first fails
        setTimeout(async () => {
          if (!showMessageModal) {
            console.log('🔔 [MOUNT] Modal not open after first attempt, trying again');
            await forceOpenModal(pendingId, true);
          }
        }, 1500);
        
        // Third attempt
        setTimeout(async () => {
          if (!showMessageModal) {
            console.log('🔔 [MOUNT] Modal still not open, final attempt');
            await forceOpenModal(pendingId, true);
          }
        }, 3000);
      }
    };
    
    if (user?.phone) {
      const timer = setTimeout(checkPendingNotification, 500);
      return () => clearTimeout(timer);
    }
  }, [user]);

  // LIVE EVENT LISTENER WITH FORCE 
  useEffect(() => {
    const handler = async (e) => {
      if (!user?.phone) {
        console.log('🔔 [EVENT] No user, waiting...');
        return;
      }
      
      const messageId = e?.detail?.messageId;
      console.log('🔔 [EVENT] openNotificationModal received:', messageId);
      
      // Store in localStorage as backup
      if (messageId) {
        try {
          localStorage.setItem('pendingNotificationId', messageId);
        } catch (err) {
          console.error('🔔 [EVENT] Failed to store in localStorage:', err);
        }
      }
      
      // Force open with ultra force
      await forceOpenModal(messageId, true);
    };
    
    window.addEventListener('openNotificationModal', handler);
    
    // Also listen for any custom events that might trigger the modal
    window.addEventListener('forceOpenNotification', handler);
    window.addEventListener('openWorkRequest', handler);
    
    return () => {
      window.removeEventListener('openNotificationModal', handler);
      window.removeEventListener('forceOpenNotification', handler);
      window.removeEventListener('openWorkRequest', handler);
    };
  }, [user, messageRequests]);

  // PENDING NOTIFICATION FROM COLD START 
  useEffect(() => {
    if (user?.phone) {
      const pendingId = window.__pendingNotificationMessageId;
      if (pendingId !== undefined && pendingId !== null) {
        console.log('🔔 [COLD START] Found pending:', pendingId);
        window.__pendingNotificationMessageId = null;
        
        setTimeout(async () => {
          await forceOpenModal(pendingId, true);
        }, 1000);
      }
    }
  }, [user]);

  // URL PARAMETER CHECK 
  useEffect(() => {
    if (!user?.phone) return;
    
    const params = new URLSearchParams(window.location.search);
    const shouldOpen = params.get('openWorkRequest');
    const messageId = params.get('messageId');
    
    if (shouldOpen || messageId) {
      console.log('🔔 [URL] Found parameters, opening modal');
      if (messageId) {
        forceOpenModal(messageId, true);
      } else {
        forceOpenModal(null, true);
      }
      
      // Clean URL
      params.delete('openWorkRequest');
      params.delete('messageId');
      const qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : ''));
    }
  }, [user]);

  // =POLLING FOR MESSAGES
  useEffect(() => {
    let pollInterval;
    let pollAttempts = 0;
    const maxPollAttempts = 5;
    
    const pollForMessages = async () => {
      if (!user?.phone || pollAttempts >= maxPollAttempts) {
        if (pollInterval) clearInterval(pollInterval);
        return;
      }
      
      try {
        const response = await getMessageByPhone(user.phone);
        if (response.success && response.count > 0) {
          setMessageRequests(response.data);
          updateMessageCount(response.count);
          
          // Check if we have a pending ID that needs to be opened
          if (window.__pendingNotificationMessageId) {
            const id = window.__pendingNotificationMessageId;
            window.__pendingNotificationMessageId = null;
            console.log('🔔 [POLL] Found pending ID during poll:', id);
            await forceOpenModal(id, true);
            if (pollInterval) clearInterval(pollInterval);
          }
        }
        pollAttempts++;
      } catch (err) {
        console.error('🔔 [POLL] Error polling:', err);
        pollAttempts++;
      }
    };
    
    if (user?.phone && !showMessageModal) {
      // Start polling after a delay
      const timer = setTimeout(() => {
        pollInterval = setInterval(pollForMessages, 2000);
      }, 3000);
      
      return () => {
        clearTimeout(timer);
        if (pollInterval) clearInterval(pollInterval);
      };
    }
  }, [user, showMessageModal]);

  // PULL-TO-REFRESH LOGIC 
  useEffect(() => {
    const PULL_THRESHOLD_RATIO = 0.65;
    const MAX_PULL_RATIO = 0.75; 

    const getThreshold = () => window.innerHeight * PULL_THRESHOLD_RATIO;
    const getMaxPull = () => window.innerHeight * MAX_PULL_RATIO;

    const handleTouchStart = (e) => {
      if (window.scrollY === 0 && !isRefreshing) {
        touchStartY.current = e.touches[0].clientY;
        isPullingRef.current = true;
      } else {
        isPullingRef.current = false;
      }
    };

    const handleTouchMove = (e) => {
      if (!isPullingRef.current || isRefreshing) return;
      const diff = e.touches[0].clientY - touchStartY.current;
      if (diff > 0 && window.scrollY === 0) {
        setPullDistance(Math.min(diff, getMaxPull()));
      } else {
        setPullDistance(0);
      }
    };

    const handleTouchEnd = () => {
      if (!isPullingRef.current) return;
      isPullingRef.current = false;

      setPullDistance((current) => {
        if (current > getThreshold() && !isRefreshing) {
          setIsRefreshing(true);
          window.location.reload();
        }
        return 0;
      });
    };

    window.addEventListener("touchstart", handleTouchStart, { passive: true });
    window.addEventListener("touchmove", handleTouchMove, { passive: true });
    window.addEventListener("touchend", handleTouchEnd, { passive: true });

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [isRefreshing]);

  const pullIndicator = (pullDistance > 0 || isRefreshing) && (
    <div
      className="fixed top-0 left-0 right-0 flex justify-center items-start z-[1000] pointer-events-none transition-[height] duration-150"
      style={{ height: `${isRefreshing ? 60 : pullDistance}px` }}
    >
      <div
        className="bg-white rounded-full shadow-md p-2 mt-2"
        style={{ opacity: isRefreshing ? 1 : Math.min(pullDistance / (window.innerHeight * 0.65), 1) }}
      >
        <svg
          className={`h-6 w-6 text-indigo-600 ${isRefreshing ? "animate-spin" : ""}`}
          style={!isRefreshing ? { transform: `rotate(${Math.min((pullDistance / (window.innerHeight * 0.65)) * 180, 180)}deg)` } : undefined}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
    </div>
  );

  // REGISTRATION STATUS CHECKS 
  const hasBasicInfo = () => {
    return (
      user?.name &&
      user.name.trim().toLowerCase() !== "n/a" &&
      user?.skills &&
      user.skills.length > 0 &&
      user?.preferredLocation &&
      user.preferredLocation.trim().toLowerCase() !== "n/a"
    );
  };

  const hasSelfie = () => {
    return user?.profilePhotoUrl;
  };

  const hasDobAndAddress = () => {
    return user?.dob && user?.address;
  };

  const hasAgreementSigned = () => {
    return user?.isAgreementSigned;
  };

  const isFullyRegistered = () => {
    return (
      hasBasicInfo() &&
      hasSelfie() &&
      hasDobAndAddress() &&
      hasAgreementSigned()
    );
  };

  // DETERMINE CURRENT REGISTRATION STEP
  useEffect(() => {
    if (!hasBasicInfo()) {
      setRegistrationStep(1);
    } else if (!hasSelfie()) {
      setRegistrationStep(2);
    } else if (!hasDobAndAddress()) {
      setRegistrationStep(3);
    } else if (hasDobAndAddress() && hasAgreementSigned() === false) {
      setRegistrationStep(4);
    } else {
      setRegistrationStep(5);
    }
  }, [user]);

  // FETCH DATA AFTER FULL REGISTRATION
  useEffect(() => {
    if (isFullyRegistered() && user?.phone) {
      fetchBankDetails();
      fetchUserStats();
      fetchCompanies();
      fetchMessageRequests();
    }
  }, [registrationStep]);

  useEffect(() => {
    if (isFullyRegistered() && user?.preferredLocation) {
      fetchCompanies();
    }
  }, [user?.preferredLocation]);

  // PROCESS MESSAGE 
  const processMessage = (message) => {
    if (!message) return { title: '', body: '' };
    
    let processedBody = message.notificationBody || '';
    let processedTitle = message.notificationTitle || '';
    
    const dynamicVars = message.campaignDynamicVariables || [];
    if (message.name) {
      processedBody = processedBody.replace(/\$\{name\}/g, message.name);
      processedTitle = processedTitle.replace(/\$\{name\}/g, message.name);
    }
    
    dynamicVars.forEach((value, index) => {
      const placeholder = `{{${index + 1}}}`;
      const regex = new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
      let replacement = value || placeholder;
      if (message.name && replacement.includes('${name}')) {
        replacement = replacement.replace(/\$\{name\}/g, message.name);
      }
      processedBody = processedBody.replace(regex, replacement);
      processedTitle = processedTitle.replace(regex, replacement);
    });
    
    return { title: processedTitle, body: processedBody };
  };

  // ============= PROOF OF WORK HANDLER =============
const handleProofOfWork = async () => {
  try {
    setIsLoadingReport(true);

    const authToken = localStorage.getItem(WORKER_TOKEN_KEY) || token;
    if (!authToken) {
      toast.error("Authentication required");
      return;
    }

    const workerIdToUse = user?.id || user?._id;
    if (!workerIdToUse) {
      toast.error("Worker ID not found");
      return;
    }

    const response = await axios.get(
      `${BASE_URL}/lenskart/profile-report/${workerIdToUse}`,
      {
        headers: { Authorization: `Bearer ${authToken}`, "Content-Type": "application/json" },
        responseType: "blob", // server sends JSON, but axios still wraps it in a Blob because of this
      }
    );

    const contentType = response.headers["content-type"] || "";
    const isInWebView = typeof window !== "undefined" && !!window.ReactNativeWebView;

    if (contentType.includes("application/json")) {
      const text = await response.data.text();
      const jsonData = JSON.parse(text);

      if (!jsonData.success) {
        throw new Error(jsonData.message || "Failed to generate profile report");
      }

      const filename = jsonData.fileName || `proof_of_work_${workerIdToUse}.pdf`;
      const mimeType = jsonData.mimeType || "application/pdf";

      // Case A: newer shape — base64 file data embedded directly
      if (jsonData.data) {
        if (isInWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: "DOWNLOAD_FILE",
            base64: jsonData.data, // already base64, no conversion needed
            mimeType,
            filename,
          }));
          toast.success("Proof of Work is ready — opening…");
        } else {
          // Browser: decode base64 -> Blob -> object URL
          const byteChars = atob(jsonData.data);
          const byteNumbers = new Array(byteChars.length);
          for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: mimeType });
          const url = window.URL.createObjectURL(blob);

          if (mimeType.includes("pdf") || mimeType.includes("html")) {
            window.open(url, "_blank");
          } else {
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          setTimeout(() => window.URL.revokeObjectURL(url), 1000);
          toast.success("Proof of Work downloaded successfully!");
        }
        return;
      }

      // Case B: older shape — hosted URL (kept for backward compatibility)
      if (jsonData.data?.url) {
        if (isInWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: "OPEN_EXTERNAL_URL",
            url: jsonData.data.url,
          }));
        } else {
          window.open(jsonData.data.url, "_blank");
        }
        toast.success("Proof of Work opened!");
        return;
      }

      // Fallback: success with nothing usable
      toast.success("Profile report generated successfully!");
      return;
    }

    // ── True binary blob fallback (PDF/HTML content-type, not JSON) ──
    // ... keep your existing blob-handling code here for non-JSON responses
  } catch (error) {
    console.error("Error fetching proof of work:", error);
    toast.error("Failed to generate Proof of Work. Please try again.");
  } finally {
    setIsLoadingReport(false);
  }
};

const handleMyEssentials = () => {
  navigate("/lkart/dashboard/my-store");
};

  // FETCH FUNCTIONS
  const fetchBankDetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/lenskart/account-details`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data && response.data.accountNumber) {
        setAccountDetails(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
    }
  };

  const fetchUserStats = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/lenskart/userStats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data && response.data.success) {
        const stats = response.data.data;
        setUserStats({
          totalWorkingHours: stats.totalWorkingHours || 0,
          totalShifts: stats.totalShifts || 0,
          totalPaymentEarned: stats.totalNetPayment || 0,
          totalNetPayment: stats.totalNetPayment || 0,
          totalEarnings: stats.totalEarnings || 0, // Store totalEarnings from API
        });
      }
    } catch (error) {
      console.error("Failed to fetch user stats:", error);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/onDemandCompanies/list-companies/${user.preferredLocationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCompanies(response.data.companies || []);
    } catch (error) {
      console.error("Failed to fetch companies:", error);
      toast.error("Failed to fetch companies");
    }
  };

  const fetchMessageRequests = async () => {
    try {
      const response = await getMessageByPhone(user.phone);
      if (response.success && response.count > 0) {
        setMessageRequests(response.data);
        updateMessageCount(response.count);
      } else {
        updateMessageCount(0);
      }
    } catch (error) {
      console.error("Failed to fetch message requests:", error);
    }
  };

  // ============= MESSAGE ACTION HANDLERS =============
  const handleMessageAction = async (action, messageId) => {
    try {
      let result;

      if (action === 'skip') {
        result = await markMessageAsRead(messageId);
        toast.info("Notification marked as read");
      } else {
        result = await submitMessageResponse(messageId, action);
        toast.success("Thankyou! Your response has been captured");
      }

      const updatedMessages = messageRequests.filter(msg => msg._id !== messageId);
      setMessageRequests(updatedMessages);
      updateMessageCount(updatedMessages.length);

      setShowMessageModal(false);
      setCurrentMessage(null);
    } catch (error) {
      console.error("Failed to submit response:", error);
      toast.error("Failed to submit response. Please try again.");
    }
  };

  const handleMessageCardClick = () => {
    if (messageRequests.length > 0) {
      const firstMessage = messageRequests[0];
      const processed = processMessage(firstMessage);
      setCurrentMessage({
        ...firstMessage,
        processedTitle: processed.title,
        processedBody: processed.body
      });
      setShowMessageModal(true);
    }
  };

  // ============= REGISTRATION FLOW HANDLERS =============
  const handleStartRegistration = () => {
    setShowWorkerDetailModal(true);
  };

  const handleWorkerDetailComplete = (isSuccess) => {
    setShowWorkerDetailModal(false);
    if (isSuccess) {
      setTimeout(() => {
        setShowSelfieModal(true);
      }, 300);
    }
  };

  const handleSelfieComplete = () => {
    setShowSelfieModal(false);
    toast.success("Selfie uploaded successfully");
    if (!hasDobAndAddress()) {
      setTimeout(() => {
        setShowDobAddressModal(true);
      }, 300);
    }
  };

  const handleDobAddressSuccess = () => {
    setShowDobAddressModal(false);
    if (!hasAgreementSigned()) {
      setTimeout(() => {
        setShowAgreementModal(true);
      }, 300);
    }
  };

  const handleAgreementSuccess = (isSuccess) => {
    setShowAgreementModal(false);
    if (isSuccess) {
      toast.success("Registration completed successfully! 🎉");
    } else {
      toast.info("Please accept the agreement to continue");
    }
  };

  // ============= DASHBOARD EDIT HANDLERS =============
  const handleEditDobAddress = () => {
    setShowDobAddressModal(true);
  };

  const handleDobAddressUpdateSuccess = () => {
    setShowDobAddressModal(false);
    setTimeout(() => {
      setShowAgreementModal(true);
    }, 300);
  };

  const handleDashboardAgreementSuccess = (isSuccess) => {
    setShowAgreementModal(false);
    if (isSuccess) {
      setUser({ ...user, isAgreementSigned: true });
      toast.success("Agreement accepted successfully!");
    } else {
      toast.info("Please accept the agreement to continue");
    }
  };

  // ============= QR CODE GENERATION =============
  const generateQR = async () => {
    try {
      const result = await fetchQRLink();
      if (!result.link) {
        throw new Error("Failed to generate QR code");
      }
      setQrLink(result.link);
      setQrStatus(result.status);
      setShowQRModal(true);
    } catch (err) {
      toast.error("Failed to generate QR code");
    }
  };

  // ============= SELFIE HANDLERS =============
  const handleProfileImageClick = () => {
    navigate('/lkart/dashboard/my-profile');
  };

  const handleReuploadSelfie = () => {
    setShowViewSelfieModal(false);
    setShowSelfieModal(true);
  };

  // ============= LOGOUT HANDLER =============
  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
  logout(); // clears worker_auth_token + worker state, owned by WorkerContext
  setShowLogoutModal(false);
  toast.success("Logged out successfully");
  navigate("/lkart/"); // matches your actual worker login route
};

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  // ============= NAVIGATION HANDLERS =============
  const goToAttendancePage = () => {
    navigate("/lkart/dashboard/view-attendance");
  };

  const goToPayoutHistoryPage = () => {
    navigate("/lkart/dashboard/my-payouts");
  };

  const goToPaymentHistoryPage = () => {
    navigate("/lkart/dashboard/payment-history");
  };

  // const goToMyReferralsPage = () => {
  //   navigate("/lkart/dashboard/my-referrals");
  // };

  const goToReferAndEarnPage = () => {
  navigate("/lkart/dashboard/refer-and-earn/worker");
};

  const goToDetailsPage = () => {
    navigate("/lkart/dashboard/my-profile");
  };

  const goToBankDetailsPage = () => {
    setShowBankDetailsCard(true);
  };
  const downloadAgreement = async () => {
    try {
      const link = await fetchDownloadLink();
      if (link) {
        window.open(link, "_blank");
        toast.success("Agreement downloaded successfully!");
      }
    } catch (err) {
      toast.error("Failed to download agreement");
    }
  };

  // ============= RENDER: REGISTRATION FLOW =============
  if (!isFullyRegistered()) {
    return (
      <div className="bg-gray-100 min-h-screen px-4 py-6 md:max-w-4xl md:mx-auto">
        {pullIndicator}
        <ToastContainer
  position="top-center"
  autoClose={3000}
  style={{ zIndex: 99999 }}
/>

        <div className="mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
            {jobDetails.title}
          </h1>
        </div>

        {/* Job Description Card */}
        <div className="bg-gradient-to-br from-white via-[#f9f9ff] to-[#eef1ff] rounded-2xl shadow-xl p-5 md:p-7 mb-6 border border-gray-100">
          <div
            className="text-gray-700 text-sm md:text-base leading-relaxed bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-5 border border-gray-200 shadow-inner"
            dangerouslySetInnerHTML={{ __html: jobDetails.description ?? "" }}
          />
        </div>

        {/* Progress Indicator - 4 STEPS */}
        <div className="bg-gradient-to-br from-white via-[#f9f9ff] to-[#eef1ff] rounded-2xl shadow-xl p-5 md:p-6 mb-6 border border-gray-100">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            Registration Progress
          </h3>
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 border border-gray-200 shadow-inner">
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1 flex flex-col items-center">
                <div className="flex items-center justify-center w-full mb-2">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${registrationStep >= 1 ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-500"}`}>
                    {registrationStep > 1 ? "✓" : "1"}
                  </div>
                </div>
                <span className="text-xs text-gray-600 text-center">Basic Info</span>
              </div>
              <div className={`flex-1 h-1 self-start mt-5 ${registrationStep > 1 ? "bg-indigo-600" : "bg-gray-200"}`}></div>
              <div className="flex-1 flex flex-col items-center">
                <div className="flex items-center justify-center w-full mb-2">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${registrationStep >= 2 ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-500"}`}>
                    {registrationStep > 2 ? "✓" : "2"}
                  </div>
                </div>
                <span className="text-xs text-gray-600 text-center">Selfie</span>
              </div>
              <div className={`flex-1 h-1 self-start mt-5 ${registrationStep > 2 ? "bg-indigo-600" : "bg-gray-200"}`}></div>
              <div className="flex-1 flex flex-col items-center">
                <div className="flex items-center justify-center w-full mb-2">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${registrationStep >= 3 ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-500"}`}>
                    {registrationStep > 3 ? "✓" : "3"}
                  </div>
                </div>
                <span className="text-xs text-gray-600 text-center">DOB & Address</span>
              </div>
              <div className={`flex-1 h-1 self-start mt-5 ${registrationStep > 3 ? "bg-indigo-600" : "bg-gray-200"}`}></div>
              <div className="flex-1 flex flex-col items-center">
                <div className="flex items-center justify-center w-full mb-2">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${registrationStep >= 4 ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-500"}`}>
                    {registrationStep > 4 ? "✓" : "4"}
                  </div>
                </div>
                <span className="text-xs text-gray-600 text-center">Agreement</span>
              </div>
            </div>
          </div>
        </div>

        {/* Personal Details Card */}
        {hasBasicInfo() && (
          <div className="bg-gradient-to-br from-white via-[#f9f9ff] to-[#eef1ff] rounded-2xl shadow-xl p-4 md:p-5 mb-6 border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <img src={worker} alt="Avatar Logo" className="w-6 h-6" />
                Personal Details
              </h3>
              <button
                onClick={() => setShowWorkerDetailModal(true)}
                className="flex items-center gap-1 px-3 py-1.5 text-sm text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50 rounded-md transition-colors border border-indigo-100"
              >
                <Edit2 className="h-4 w-4" />
                <span className="hidden sm:inline font-medium">Edit</span>
              </button>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-3 md:p-4 border border-gray-200 shadow-inner text-gray-700 text-sm md:text-base space-y-2">
              <p><strong>Name:</strong> {user.name}</p>
              <p><strong>Gender:</strong> {user.gender}</p>
              <p><strong>{user.relativeType} contact no:</strong> {user.relativeNumber} ({user.relativeName})</p>
              <p><strong>Highest education:</strong> {user.highestQualification}</p>
              {user.lastcompanyName && (
                <p><strong>Last company:</strong> {user.lastcompanyName}</p>
              )}
              <p><strong>Current Address:</strong> {user.temporaryAddress}</p>
              <p><strong>Skills:</strong> {user.skills.slice(0, 5).join(", ")}</p>
              <p><strong>Location:</strong> {user.preferredLocation}</p>
            </div>
          </div>
        )}

        {/* Selfie Preview Card */}
        {hasSelfie() && (
          <div className="bg-gradient-to-br from-white via-[#f9f9ff] to-[#eef1ff] rounded-2xl shadow-xl p-4 md:p-5 mb-6 border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                📸 Profile Photo
              </h3>
              <button
                onClick={() => setShowSelfieModal(true)}
                className="flex items-center gap-1 px-3 py-1.5 text-sm text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50 rounded-md transition-colors border border-indigo-100"
              >
                <Camera className="h-4 w-4" />
                <span className="hidden sm:inline font-medium">Retake</span>
              </button>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-3 md:p-4 border border-gray-200 shadow-inner">
              <img
                src={user.profilePhotoUrl}
                alt="Profile"
                className="w-32 h-32 rounded-full object-cover border-4 border-green-500 mx-auto"
              />
            </div>
          </div>
        )}

        {/* DOB & Address Preview Card */}
        {hasDobAndAddress() && (
          <div className="bg-gradient-to-br from-white via-[#f9f9ff] to-[#eef1ff] rounded-2xl shadow-xl p-4 md:p-5 mb-6 border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                📄 DOB & Address
              </h3>
              <button
                onClick={() => setShowDobAddressModal(true)}
                className="flex items-center gap-1 px-3 py-1.5 text-sm text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50 rounded-md transition-colors border border-indigo-100"
              >
                <Edit2 className="h-4 w-4" />
                <span className="hidden sm:inline font-medium">Edit</span>
              </button>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-lg p-3 md:p-4 border border-gray-200 shadow-inner text-gray-700 text-sm md:text-base space-y-2">
              <p><strong>Date of Birth:</strong> {user?.dob ?? "Not provided"}</p>
              <p><strong>Address:</strong> {user.address || "Not provided"}</p>
            </div>
          </div>
        )}

        {/* Action Button */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6">
          {registrationStep === 1 && (
            <button
              onClick={handleStartRegistration}
              className="w-full py-3.5 px-5 rounded-xl font-semibold flex items-center justify-center gap-3 text-white transition-all duration-300 shadow-md hover:shadow-lg bg-gradient-to-r from-indigo-600 via-indigo-500 to-blue-500 hover:from-indigo-700 hover:via-indigo-600 hover:to-blue-600"
            >
              <span className="text-xl">🚀</span>
              <span>Start Registration</span>
            </button>
          )}
          {registrationStep === 2 && (
            <button
              onClick={() => setShowSelfieModal(true)}
              className="w-full py-3.5 px-5 rounded-xl font-semibold flex items-center justify-center gap-3 text-white transition-all duration-300 shadow-md hover:shadow-lg bg-gradient-to-r from-indigo-600 via-indigo-500 to-blue-500 hover:from-indigo-700 hover:via-indigo-600 hover:to-blue-600"
            >
              <Camera className="h-5 w-5" />
              <span>Upload Selfie</span>
            </button>
          )}
          {registrationStep === 3 && (
            <button
              onClick={() => setShowDobAddressModal(true)}
              className="w-full py-3.5 px-5 rounded-xl font-semibold flex items-center justify-center gap-3 text-white transition-all duration-300 shadow-md hover:shadow-lg bg-gradient-to-r from-indigo-600 via-indigo-500 to-blue-500 hover:from-indigo-700 hover:via-indigo-600 hover:to-blue-600"
            >
              <span className="text-xl">📄</span>
              <span>Complete DOB & Address</span>
            </button>
          )}
          {registrationStep === 4 && (
            <button
              onClick={() => setShowAgreementModal(true)}
              className="w-full py-3.5 px-5 rounded-xl font-semibold flex items-center justify-center gap-3 text-white transition-all duration-300 shadow-md hover:shadow-lg bg-gradient-to-r from-green-600 via-green-500 to-emerald-500 hover:from-green-700 hover:via-green-600 hover:to-emerald-600"
            >
              <span className="text-xl">✍️</span>
              <span>Accept Agreement</span>
            </button>
          )}
        </div>

        {/* Modals */}
        {showWorkerDetailModal && (
          <WorkerDetailModal
            isOpen={showWorkerDetailModal}
            onClose={handleWorkerDetailComplete}
            initialData={user}
            editType={editType}
          />
        )}

        {showSelfieModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl w-full max-w-md relative">
              <SelfieImage
                onSuccess={handleSelfieComplete}
                onClose={() => setShowSelfieModal(false)}
                mandatory={true}
                token={token}
                setUser={setUser}
              />
            </div>
          </div>
        )}

        {showDobAddressModal && (
          <DobAddressModal
            onClose={() => setShowDobAddressModal(false)}
            onSuccess={handleDobAddressSuccess}
            isEditing={hasDobAndAddress()}
          />
        )}

        {showAgreementModal && (
          <AgreementModal
            onClose={handleAgreementSuccess}
            onSuccess={handleAgreementSuccess}
          />
        )}

        {/* Logout Button - Bottom of Registration Flow */}
        <div className="mt-6 pt-4 border-t border-gray-200 text-center">
          <button
            onClick={handleLogout}
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200 border border-red-200 hover:border-red-300"
          >
            <LogOut className="h-4 w-4" />
            <span>Logout</span>
          </button>
        </div>

        {/* Custom Logout Confirmation Modal */}
        {showLogoutModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[999]">
            <div className="bg-white rounded-2xl w-full max-w-sm p-6 relative shadow-2xl">
              <div className="text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <LogOut className="h-8 w-8 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Logout</h3>
                <p className="text-gray-600 mb-6">
                  Are you sure you want to logout from your account?
                </p>
                <div className="flex gap-3">
                  <button
                    onClick={cancelLogout}
                    className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={confirmLogout}
                    className="flex-1 py-2.5 px-4 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ============= RENDER: MAIN DASHBOARD =============
  return (
    <div className="bg-gray-100 px-4 py-6 md:max-w-4xl md:mx-auto ">
      {pullIndicator}
      <ToastContainer
  position="top-center"
  autoClose={3000}
  style={{ zIndex: 99999 }}
/>

      {/* ─── Welcome Header ──────────── */}
      <div className="bg-[#E2E1FD] -mx-4 px-4 pt-12 pb-0 rounded-b-3xl relative overflow-visible -mt-12 mb-12">

        {/* Profile + Name + QR row */}
        <div className="flex items-center justify-between max-w-4xl mx-auto">
          <div className="flex items-center gap-3">
            <img
              src={user?.profilePhotoUrl}
              alt="Profile"
              onClick={handleProfileImageClick}
              className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-md cursor-pointer hover:scale-105 transition-all duration-200"
              title="Click to view profile"
            />
            <div>
              <p className="text-[10px] font-bold text-indigo-700 uppercase tracking-[0.15em]">Welcome back,</p>
              <p className="text-xl font-bold text-gray-900 leading-tight">{user?.name}</p>
            </div>
          </div>
          <button
            onClick={generateQR}
            className="w-[72px] h-[72px] bg-white rounded-xl flex items-center justify-center shadow-md border border-indigo-100 hover:shadow-lg transition-all duration-200 hover:scale-105 flex-shrink-0 p-1.5"
            title="Generate Attendance QR"
          >
            <QRCode value={qrlink || "https://factrika.com"} size={56} />
          </button>
        </div>

        {/* Stats white card */}
        <div className="max-w-4xl mx-auto px-4 relative z-10 translate-y-5">
          <div className="bg-white rounded-2xl shadow-md py-4 px-1">
            <AttendanceCard
              userStats={userStats}
              setShowPaymentSummaryModal={() => navigate("/lkart/dashboard/work-summary")}
            />
          </div>
        </div>

        {/* Message request banner */}
        {messageRequests.length > 0 && (
          <div className="max-w-4xl mx-auto px-4 mt-6 relative" onClick={handleMessageCardClick}>
            {messageRequests.length > 1 && (
              <div className="absolute -top-1.5 left-2 right-2 h-full bg-indigo-300 rounded-xl opacity-40 transform rotate-1" />
            )}
            <div className="relative cursor-pointer bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-xl px-4 py-3 shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-white/20 rounded-full flex items-center justify-center text-xl">📬</div>
                <p className="font-semibold text-sm">New Work Request</p>
              </div>
              {messageRequests.length > 1 && (
                <div className="bg-white/25 px-2.5 py-0.5 rounded-full text-xs font-bold">
                  {messageRequests.length} new
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <CompaniesSection 
        companies={companies}
        user={user}
        token={token}
        preferredLocation={user.preferredLocation}
      />

      {/* ─── Quick Actions Grid ───────────────────────────────── */}
{/* ─── Quick Actions Grid ───────────────────────────────── */}
<div className="mb-6 mt-2 ml-2">
  <h3 className="text-sm font-bold font-montserrat text-[#202020] flex items-center mb-4">
    Quick Actions
  </h3>
  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-2">

    {/* Row 1 */}
    <div className="grid grid-cols-3">
      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={goToAttendancePage}>
          <img src={attendaceIcon} alt="Attendance" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">Attendance</p>
      </div>

      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={goToPayoutHistoryPage}>
          <img src={payoutsIcon} alt="Payouts" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">My Payouts</p>
      </div>

      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={goToReferAndEarnPage}>
          <img src={referralIcon} alt="Refer&Earn" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">Refer & Earn</p>
      </div>
    </div>

    {/* Row 2 */}
    <div className="grid grid-cols-3">
      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={goToDetailsPage}>
          <img src={detailsIcon} alt="My Details" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">My Profile</p>
      </div>

      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={goToBankDetailsPage}>
          <img src={bankDetailsIcon} alt="Bank Details" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">Bank Details</p>
      </div>

      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={downloadAgreement}>
          <img src={agreementIcon} alt="Download Agreement" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">Agreement</p>
      </div>
    </div>

    {/* Row 3 — NEW */}
    <div className="grid grid-cols-3">
      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={handleProofOfWork} disabled={isLoadingReport}>
          {isLoadingReport ? (
            <div className="w-8 h-8 flex items-center justify-center">
              <svg
                className="h-6 w-6 text-indigo-600 animate-spin"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
            </div>
          ) : (
            <img src={powIcon} alt="Proof of Work" className="w-8 h-8" />
          )}
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">
          {isLoadingReport ? "Loading..." : "Proof of Work"}
        </p>
      </div>

      <div className="flex flex-col items-center gap-4 py-5 px-2">
        <button onClick={handleMyEssentials}>
          <img src={essentialsIcon} alt="My Store" className="w-8 h-8" />
        </button>
        <p className="text-xs font-medium font-montserrat whitespace-nowrap text-gray-800">My Store</p>
      </div>

      {/* Empty third cell keeps grid alignment */}
      <div className="flex flex-col items-center gap-4 py-5 px-2" />
    </div>

  </div>
</div>

      {/* ─── Modals ─────────────────────────────────────────────────────────── */}
      {showWorkerDetailModal && (
        <WorkerDetailModal
          isOpen={showWorkerDetailModal}
          onClose={(isSuccess) => {
            setShowWorkerDetailModal(false);
            setEditType(null);
            if (isSuccess && editType) {
              toast.success("Personal details updated successfully!");
            }
          }}
          initialData={user}
          editType={editType}
        />
      )}


      {showQRModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl w-full max-w-sm p-6 relative">
            <button onClick={() => setShowQRModal(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
              <X className="h-6 w-6" />
            </button>
            <div className="text-center mb-4">
              <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium mb-3 ${qrStatus === "entry" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
                {qrStatus === "entry" ? (
                  <><span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>Entry QR Code</>
                ) : (
                  <><span className="w-2 h-2 bg-red-500 rounded-full mr-2"></span>Exit QR Code</>
                )}
              </div>
              <p className="font-semibold text-gray-900 mb-5">Attendance QR Code</p>
              <QRCode value={qrlink} size={200} className="mx-auto" />
            </div>
            <div className="space-y-2 text-center text-sm">
              <p className="text-gray-600">
                {qrStatus === "entry" ? "Scan this QR code to mark your entry" : "Scan this QR code to mark your exit"}
              </p>
            </div>
          </div>
        </div>
      )}

      {showViewSelfieModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl w-full max-w-md relative overflow-hidden shadow-2xl">
            <div className="flex items-center justify-between p-6 border-b border-gray-100">
              <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                <Camera className="h-5 w-5 text-indigo-600" />
                Your Profile Photo
              </h3>
              <button onClick={() => setShowViewSelfieModal(false)} className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200">
                <X className="h-5 w-5 text-gray-500 hover:text-gray-700" />
              </button>
            </div>
            <div className="relative p-6">
              <div className="relative group">
                <img
                  src={user?.profilePhotoUrl}
                  alt="Current Selfie"
                  className="w-full h-auto rounded-xl shadow-lg border border-gray-200 max-h-[60vh] object-contain"
                />
                <button
                  onClick={handleReuploadSelfie}
                  className="absolute bottom-4 right-4 w-12 h-12 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl"
                  title="Change Photo"
                >
                  <Camera className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSelfieModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl w-full max-w-md relative">
            <SelfieImage
              onSuccess={handleSelfieComplete}
              onClose={() => setShowSelfieModal(false)}
              mandatory={true}
              token={token}
              setUser={setUser}
            />
          </div>
        </div>
      )}

      {showDobAddressModal && (
        <DobAddressModal
          onClose={() => setShowDobAddressModal(false)}
          onSuccess={handleDobAddressUpdateSuccess}
          isEditing={!!user?.aadharVerified}
        />
      )}

      {showAgreementModal && (
        <AgreementModal
          onClose={handleDashboardAgreementSuccess}
          onSuccess={handleDashboardAgreementSuccess}
        />
      )}

      {/* {showAadhaarModal && (
        <AdhaarVerificationModal
          onClose={() => setShowAadhaarModal(false)}
          onSuccess={() => {
            setShowAadhaarModal(false);
            setTimeout(() => { setShowDobAddressModal(true); }, 300);
          }}
          isEditing={false}
          title="Update Your Aadhaar"
        />
      )} */}

      {/* Bank Details Card */}
      {showBankDetailsCard && (
        <BankDetailsCard
          isOpen={showBankDetailsCard}
          onClose={() => setShowBankDetailsCard(false)}
        />
      )}


      {/* Message Modal */}
      {showMessageModal && currentMessage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl w-full max-w-md relative shadow-2xl max-h-[90vh] flex flex-col">
            <div className="p-6 border-b border-gray-200 flex-shrink-0">
              <h3 className="text-xl font-semibold text-gray-900">Work Request</h3>
            </div>
            <div className="p-6 overflow-y-auto flex-1">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                {currentMessage.processedTitle && (
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">
                    {currentMessage.processedTitle}
                  </h4>
                )}
                <p className="text-gray-700 leading-relaxed whitespace-pre-wrap break-words">
                  {currentMessage.processedBody}
                </p>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex gap-3 flex-shrink-0">
  {currentMessage.notificationButton1 && (
    <button
      onClick={() => handleMessageAction(currentMessage.notificationButton1, currentMessage._id)}
      className="flex-1 py-2.5 px-4 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors font-medium"
    >
      {currentMessage.notificationButton1}
    </button>
  )}
  {currentMessage.notificationButton2 && (
    <button
      onClick={() => handleMessageAction(currentMessage.notificationButton2, currentMessage._id)}
      className="flex-1 py-2.5 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
    >
      {currentMessage.notificationButton2}
    </button>
  )}
  <button
    onClick={() => handleMessageAction('skip', currentMessage._id)}
    className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
  >
    Skip
  </button>
</div>
          </div>
        </div>
      )}

      {/* Logout Button - Bottom of Main Dashboard */}
      <div className="mt-6 pt-4 border-t border-gray-200 text-center">
        <button
          onClick={handleLogout}
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all duration-200 border border-red-200 hover:border-red-300"
        >
          <LogOut className="h-4 w-4" />
          <span>Logout</span>
        </button>
      </div>

      {/* Custom Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[999]">
          <div className="bg-white rounded-2xl w-full max-w-sm p-6 relative shadow-2xl">
            <button 
              onClick={cancelLogout}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <LogOut className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Logout</h3>
              <p className="text-gray-600 mb-6">
                Are you sure you want to logout from your account?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={cancelLogout}
                  className="flex-1 py-2.5 px-4 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmLogout}
                  className="flex-1 py-2.5 px-4 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobDetailsView;